import { useAuth } from '../hooks/useAuth'

export default function ProfilePage() {
  const { profile, signOut } = useAuth()

  return (
    <div style={s.page}>
      {/* User card */}
      <div style={s.card}>
        <div style={s.avatar}>{(profile?.full_name || profile?.email || 'U')[0].toUpperCase()}</div>
        <h2 style={s.name}>{profile?.full_name || 'Χρήστης'}</h2>
        <p style={s.email}>{profile?.email}</p>
      </div>

      {/* Stats */}
      <div style={s.statsCard}>
        <div style={s.statItem}>
          <div style={s.statVal}>{profile?.points || 0}</div>
          <div style={s.statLbl}>Πόντοι</div>
        </div>
        <div style={s.divider} />
        <div style={s.statItem}>
          <div style={s.statVal}>{profile?.total_scans || 0}</div>
          <div style={s.statLbl}>Ανακυκλώσεις</div>
        </div>
        <div style={s.divider} />
        <div style={s.statItem}>
          <div style={s.statVal}>{((profile?.total_scans || 0) * 0.3).toFixed(1)}kg</div>
          <div style={s.statLbl}>CO₂ εξοικ.</div>
        </div>
      </div>

      {/* How it works */}
      <div style={s.card}>
        <h3 style={s.sectionTitle}>Πώς λειτουργεί</h3>
        {[
          ['📱', 'Σκανάρισε το QR στον κάδο'],
          ['📍', 'GPS επαλήθευση τοποθεσίας'],
          ['🛍️', 'Φωτογράφισε τη σακούλα (live)'],
          ['🎉', 'Κέρδισε +5 πόντους'],
          ['🎁', 'Εξαργύρωσε σε καταστήματα & υπηρεσίες'],
        ].map(([icon, text]) => (
          <div key={text} style={s.howRow}>
            <span style={s.howIcon}>{icon}</span>
            <span style={s.howText}>{text}</span>
          </div>
        ))}
      </div>

      {/* Security */}
      <div style={s.card}>
        <h3 style={s.sectionTitle}>Ασφάλεια & Επαλήθευση</h3>
        {[
          ['🔒', 'QR + Geolocation επαλήθευση'],
          ['📸', 'Live φωτογραφία σακούλας (timestamp <30δλ)'],
          ['🔍', 'Τυχαίος spot-check ανοιχτού κάδου (30%)'],
          ['🤖', 'Anomaly detection για ύποπτα patterns'],
          ['⏱️', 'Max 2 σκαναρίσματα/κάδο/ημέρα'],
        ].map(([icon, text]) => (
          <div key={text} style={s.howRow}>
            <span style={s.howIcon}>{icon}</span>
            <span style={s.howText}>{text}</span>
          </div>
        ))}
      </div>

      {/* Developed by Softminds */}
      <div style={s.devCard}>
        <div style={s.devLogo}>
          <span style={s.devLogoIcon}>🧠</span>
          <div>
            <div style={s.devName}>Softminds</div>
            <div style={s.devTagline}>Web & Mobile Development</div>
          </div>
        </div>
        <div style={s.devDivider} />
        <div style={s.devTeam}>
          <div style={s.devMember}>
            <span style={s.devMemberName}>Marianna Vouraki</span>
            <a href="https://softminds.gr/page-of-member/mariannavouraki/" target="_blank" rel="noopener noreferrer" style={s.devLink}>Profile ↗</a>
          </div>
          <div style={s.devMember}>
            <span style={s.devMemberName}>Karipidis Theodoros</span>
            <a href="https://softminds.gr/page-of-member/karipidis-theodoros/" target="_blank" rel="noopener noreferrer" style={s.devLink}>Profile ↗</a>
          </div>
        </div>
        <a href="https://softminds.gr" target="_blank" rel="noopener noreferrer" style={s.devWebsite}>
          🌐 softminds.gr
        </a>
        <div style={s.devContest}>ΕΕΔΣΑ Διαγωνισμός Καινοτομίας 2026</div>
      </div>

      <button style={s.signOutBtn} onClick={signOut}>Αποσύνδεση</button>
    </div>
  )
}

const s = {
  page: { padding:'1rem', maxWidth:480, margin:'0 auto', display:'flex', flexDirection:'column', gap:'1rem' },
  card: { background:'white', borderRadius:16, padding:'1.25rem', boxShadow:'0 2px 12px rgba(0,0,0,0.06)' },
  avatar: { width:72, height:72, borderRadius:'50%', background:'#1A6B3C', color:'white', fontSize:32, fontWeight:700, display:'flex', alignItems:'center', justifyContent:'center', margin:'0 auto 12px' },
  name: { margin:'0 0 4px', fontSize:22, color:'#1A6B3C', textAlign:'center' },
  email: { margin:0, color:'#888', fontSize:14, textAlign:'center' },
  statsCard: { background:'white', borderRadius:16, padding:'1.25rem', boxShadow:'0 2px 12px rgba(0,0,0,0.06)', display:'flex', alignItems:'center' },
  statItem: { flex:1, textAlign:'center' },
  statVal: { fontSize:24, fontWeight:700, color:'#1A6B3C' },
  statLbl: { fontSize:12, color:'#888', marginTop:4 },
  divider: { width:1, height:40, background:'#f0f0f0' },
  sectionTitle: { margin:'0 0 12px', fontSize:15, fontWeight:600, color:'#333' },
  howRow: { display:'flex', alignItems:'center', gap:12, padding:'8px 0', borderBottom:'1px solid #f5f5f5' },
  howIcon: { fontSize:20, width:30, textAlign:'center', flexShrink:0 },
  howText: { fontSize:14, color:'#555' },
  devCard: { background:'#1B2A4A', borderRadius:16, padding:'1.25rem', boxShadow:'0 2px 12px rgba(0,0,0,0.15)' },
  devLogo: { display:'flex', alignItems:'center', gap:12, marginBottom:12 },
  devLogoIcon: { fontSize:36, background:'rgba(255,255,255,0.1)', borderRadius:12, width:52, height:52, display:'flex', alignItems:'center', justifyContent:'center' },
  devName: { color:'white', fontWeight:700, fontSize:20 },
  devTagline: { color:'rgba(255,255,255,0.6)', fontSize:13 },
  devDivider: { height:1, background:'rgba(255,255,255,0.1)', margin:'12px 0' },
  devTeam: { display:'flex', flexDirection:'column', gap:8, marginBottom:14 },
  devMember: { display:'flex', justifyContent:'space-between', alignItems:'center' },
  devMemberName: { color:'rgba(255,255,255,0.85)', fontSize:14 },
  devLink: { color:'#4CAF50', fontSize:13, textDecoration:'none' },
  devWebsite: { display:'block', background:'rgba(255,255,255,0.1)', borderRadius:8, padding:'10px', textAlign:'center', color:'white', fontWeight:600, fontSize:15, textDecoration:'none', marginBottom:8 },
  devContest: { textAlign:'center', color:'rgba(255,255,255,0.45)', fontSize:12, fontStyle:'italic' },
  signOutBtn: { padding:'13px', background:'white', border:'1px solid #fca5a5', color:'#dc2626', borderRadius:12, fontSize:15, fontWeight:600, cursor:'pointer' },
}
